<template>
  <div class="profile pb-4">
    <div class="card profile-info">
      <div class="card-body">
        <MembershipCard />
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent } from 'vue';
  import MembershipCard from '@/components/Profile/MembershipCard.vue';

  export default defineComponent({
    name: 'Subscription',
    components: { MembershipCard },
  });
</script>
